import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import QueryParams from 'eflex/constants/bi-query-params';
import { processDataReports } from 'eflex/constants/bi-report-options';
import moment from 'moment-timezone';

export default class BiProcessDataController extends Controller {
  // jscpd:ignore-start
  @tracked drawerCollapsed = false;
  @tracked userIds = [];
  @tracked modelIds = [];
  @tracked stationIds = [];
  @tracked tags = [];
  @tracked shiftNames = [];
  @tracked beginDate = moment().startOf('day').toISOString();
  @tracked endDate = moment().endOf('day').toISOString();
  @tracked variableDefIds = [];
  @tracked selectedToken;
  @tracked refresher = false;

  queryParams = Object.keys(QueryParams);
  selectedReport = processDataReports.processDatum;

  get reportOptions() {
    return Object.values(processDataReports);
  }

  @action
  onSearch(params) {
    this.resetCriteria();
    Object.assign(this, params);
  }

  @action
  resetCriteria() {
    Object.assign(this, {
      userIds: [],
      modelIds: [],
      stationIds: [],
      tags: [],
      shiftNames: [],
      beginDate: null,
      endDate: null,
      variableDefIds: [],
    });
  }

  @action
  refresh() {
    this.refresher = true;
  }
  // jscpd:ignore-end
}
